import { render, staticRenderFns } from "./nyanClockDesign.vue?vue&type=template&id=83b52d5a&scoped=true"
import script from "./nyanClockDesign.vue?vue&type=script&lang=js"
export * from "./nyanClockDesign.vue?vue&type=script&lang=js"
import style0 from "./nyanClockDesign.vue?vue&type=style&index=0&id=83b52d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b52d5a",
  null
  
)

export default component.exports